import { MultiUrlPicker } from '../models';

export const extractUrl = (multiUrlPicker: MultiUrlPicker): string =>
  multiUrlPicker[0] && multiUrlPicker[0].url
    ? `${multiUrlPicker[0].url}${multiUrlPicker[0].queryString || ''}`
    : '';

export default extractUrl;
